function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 3.5a8.5 8.5 0 0 1 8.5 8.501 8.502 8.502 0 0 1-5.808 8.066c-.43.083-.584-.182-.584-.408v-.145c.002-.295.007-.848.009-1.536v-.428l.001-.224c0-.793-.272-1.31-.576-1.574 1.892-.21 3.88-.93 3.88-4.195 0-.928-.329-1.686-.874-2.282.088-.214.38-1.079-.083-2.25 0 0-.713-.228-2.336.872A8.167 8.167 0 0 0 12 7.61a8.146 8.146 0 0 0-2.127.286c-1.625-1.1-2.339-.872-2.339-.872-.461 1.171-.17 2.036-.082 2.25a3.29 3.29 0 0 0-.876 2.282c0 3.258 1.985 3.986 3.873 4.201-.243.213-.463.588-.54 1.137-.485.217-1.715.593-2.473-.706l-.024-.04c-.103-.165-.54-.785-1.28-.837H6.11c-.127.004-.73.042-.035.517l.022.012c.106.06.58.365.921 1.232 0 0 .5 1.517 2.864 1.003.003.592.01 1.156.011 1.445v.138c0 .224-.155.488-.58.409A8.503 8.503 0 0 1 12 3.5z",
  fill: "#999",
  fillRule: "evenodd"
});

function SvgIco24FooterGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24FooterGithub);
export default __webpack_public_path__ + "static/media/ico_24_footer_github.e5f07227.svg";
export { ForwardRef as ReactComponent };